import React from 'react';
import {PdfPageContext} from './PdfPageContext';

export const usePdfPageContext = () => React.useContext(PdfPageContext);
